module.exports = __webpack_public_path__ + "media/src/img/payment/close-form-52a60d55b1ea81b8a3098367751e5830.svg";